import { getContentByRef } from "./get-content-by-ref.js";
const getPageRoot = (pageModel, refPrefix) => {
  if (!pageModel) {
    return void 0;
  }
  if (!pageModel.root) {
    return void 0;
  }
  const pageReferenceRef = pageModel.root.$ref;
  const pageRootComponent = getContentByRef(pageReferenceRef, pageModel, refPrefix);
  return pageRootComponent;
};
export {
  getPageRoot
};
//# sourceMappingURL=get-page-root.js.map
